import { FC, useEffect, useRef } from 'react'
import { Barcode } from 'types'

type Props = {
    onScan: (barcode: string) => void
}

export const BarcodeReader : FC < Props > = ({ onScan }) => {

    const isMounted = useRef<boolean>(true)
    const barcode = useRef<string>('')

    useEffect(() => {
        isMounted.current = true
        return () => {
            isMounted.current = false
            // document.onkeyup = null
        }
    })

    document.onkeyup = function (e: KeyboardEvent) {
        if(isMounted.current) {
            //the scanner is set up to prefix barcodes with 5 spaces.
            //This will allow us to differenciat between a barcode/user input
            if(barcode.current.length >= 5) {
                //enter key is sent by reader, indicating input has stopped
                if (e.key === 'Enter' && barcode.current.trim().length > 0) {
                    onScan(barcode.current)
                    barcode.current = ''
                }
                else if(e.key === 'Shift'){
                    barcode.current = barcode.current
                }
                else {
                    barcode.current = barcode.current ? barcode.current + e.key : e.key //Do nothing in case of non-numerical character
                }

            } else {
                barcode.current = e.key === ' ' ? barcode.current + e.key : barcode.current = ''
            }
        }
    }

    return null;
}